// Sysco regional operating companies — Salesforce-facing identifiers used verbatim as both the
// option label and the opco value written to Salesforce's Lead_Source_Location__c field. Do not
// reorder or relabel without confirming with Salesforce.
const SYSCO_OPCOS = [
  'Sysco - Acadiana', 'Sysco - Alaska', 'Sysco - Albany', 'Sysco - Arizona', 'Sysco - Arkansas',
  'Sysco - Atlanta', 'Sysco - Baltimore', 'Sysco - Baraboo', 'Sysco - Boston', 'Sysco - Calgary',
  'Sysco - Central Alabama', 'Sysco - Central California', 'Sysco - Central Florida',
  'Sysco - Central Illinois', 'Sysco - Central Pennsylvania', 'Sysco - Central Texas',
  'Sysco - Charlotte', 'Sysco - Chicago', 'Sysco - Cincinnati', 'Sysco - Cleveland',
  'Sysco - Columbia', 'Sysco - Connecticut', 'Sysco - Denver', 'Sysco - Detroit', 'Sysco - Doerle',
  'Sysco - Eastern Maryland', 'Sysco - Eastern Wisconsin', 'Sysco - East Texas', 'Sysco - Edmonton',
  'Sysco - Grand Montreal', 'Sysco - Grand Rapids', 'Sysco - Gulf Coast', 'Sysco - Halifax',
  'Sysco - Hampton Roads', 'Sysco - Hawaii', 'Sysco - Houston', 'Sysco - Idaho',
  'Sysco - Indianapolis', 'Sysco - Intermountain', 'Sysco - Iowa', 'Sysco - Jackson',
  'Sysco - Jacksonville', 'Sysco - Kansas City', 'Sysco - Kelowna', 'Sysco - Knoxville',
  'Sysco - Las Vegas', 'Sysco - Lincoln', 'Sysco - Long Island', 'Sysco - Los Angeles',
  'Sysco - Louisville', 'Sysco - Memphis', 'Sysco - Metro New York', 'Sysco - Milton',
  'Sysco - Minnesota', 'Sysco - Moncton', 'Sysco - Montana', 'Sysco - Nashville',
  'Sysco - New Mexico', 'Sysco - New Orleans', 'Sysco - North Dakota',
  'Sysco - Northern New England', 'Sysco - North Texas', 'Sysco - Oklahoma', 'Sysco - Orlando',
  'Sysco - Ottawa', 'Sysco - Peterborough', 'Sysco - Philadelphia', 'Sysco - Pittsburgh',
  'Sysco - Portland', 'Sysco - Raleigh', 'Sysco - Regina', 'Sysco - Riverside',
  'Sysco - Sacramento', 'Sysco - San Diego', 'Sysco - San Francisco', 'Sysco - Saskatchewan',
  'Sysco - Seattle', 'Sysco - Southeast Florida', 'Sysco - South Florida', 'Sysco - Southwestern',
  'Sysco - Spokane', 'Sysco - St. John\'s', 'Sysco - St. Louis', 'Sysco - Syracuse',
  'Sysco - Thunder Bay', 'Sysco - Toronto', 'Sysco - Vancouver', 'Sysco - Ventura',
  'Sysco - Victoria', 'Sysco - Virginia', 'Sysco - West Coast Florida', 'Sysco - Western Minnesota',
  'Sysco - West Texas', 'Sysco - Winnipeg',
] as const;

export const SYSCO_OPCO_OPTIONS = SYSCO_OPCOS.map(opco => ({ label: opco, value: opco }));
